import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import { useIsMobileDevice } from './useIsMobileDevice'
import { getOptimizelyEnabledDecision } from 'lib/optimizely/optimizelyUtils'

export type ShareVariant = 'control' | 'variant'

function useShareVariant(): ShareVariant {
  const isMobileDevice = useIsMobileDevice()
  const experimentVariant: string | undefined = useOptimizelyExperiment(
    OptimizelyExperiments.croNativeShareModalMobileWeb,
    isMobileDevice,
  )

  if (!isMobileDevice || !experimentVariant) return 'control'

  return getOptimizelyEnabledDecision(experimentVariant) ? 'variant' : 'control'
}

export default useShareVariant
